import axios from 'axios';
import { API_URL } from './utils';

/**
 * Fetch persons (students) by a list of ids, batched so the URL never
 * exceeds proxy limits. Returns minimal lookup fields per record.
 */
export async function fetchPersonsByIds(ids, chunkSize = 100) {
  const unique = Array.from(new Set((ids || []).filter(Boolean)));
  if (unique.length === 0) return [];
  const chunks = [];
  for (let i = 0; i < unique.length; i += chunkSize) {
    chunks.push(unique.slice(i, i + chunkSize));
  }
  const results = await Promise.all(
    chunks.map((chunk) =>
      axios
        .get(`${API_URL}/persons/lookup`, { params: { ids: chunk.join(',') } })
        .then((r) => r.data?.items || [])
        .catch((err) => {
          console.error('persons/lookup chunk failed:', err);
          return [];
        })
    )
  );
  const seen = new Set();
  const out = [];
  for (const list of results) {
    for (const p of list) {
      if (p?.id && !seen.has(p.id)) {
        seen.add(p.id);
        out.push(p);
      }
    }
  }
  return out;
}

/**
 * Search persons by free-text. Returns up to `limit` lookup-shaped records.
 */
export async function searchPersons(query, limit = 50) {
  const params = { limit };
  const trimmed = (query || '').trim();
  if (trimmed) params.search = trimmed;
  try {
    const res = await axios.get(`${API_URL}/persons/lookup`, { params });
    return res.data?.items || [];
  } catch (err) {
    console.error('persons/lookup search failed:', err);
    return [];
  }
}
